import api from './api';
import {AppResponse} from "../models/common/app-response";
import { UserDto } from '../models/users/userDto';

class UsersService {

  baseUrl: string = "/api/v1/users";

    getCurrent() {
        return api.get<AppResponse<UserDto>>(`${this.baseUrl}/current`);
    }

    updateCurrent(data: FormData) {
        return api.put<AppResponse<UserDto>>(`${this.baseUrl}/current`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    toggleDismissal(id: number, isDismissed: boolean) {
        return api.patch<AppResponse<number>>(`${this.baseUrl}/${id}/dismiss?isDismissed=${isDismissed}`);
    }

    unlinkEsia(id: number) {
        return api.patch<AppResponse<number>>(`${this.baseUrl}/${id}/unlink-esia`);
    }
}

export const usersService = new UsersService();
